import { WorkTypesQueryParams } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import * as WorkTypesActions from './work-types.actions';
import { CreateWorkTypeData, UpdateWorkTypeData } from './work-types.actions';
import * as WorkTypesSelectors from './work-types.selectors';

@Injectable({
  providedIn: 'root',
})
export class WorkTypesFacade {
  private store = inject(Store);

  workTypes$ = this.store.select(WorkTypesSelectors.selectAllWorkTypes);
  loading$ = this.store.select(WorkTypesSelectors.selectWorkTypesLoading);
  error$ = this.store.select(WorkTypesSelectors.selectWorkTypesError);
  pagination$ = this.store.select(WorkTypesSelectors.selectWorkTypesPagination);

  workTypes = toSignal(this.workTypes$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadWorkTypes(params?: WorkTypesQueryParams): void {
    this.store.dispatch(WorkTypesActions.loadWorkTypes({ params }));
  }

  createWorkType(workTypeData: CreateWorkTypeData): void {
    this.store.dispatch(WorkTypesActions.createWorkType({ workTypeData }));
  }

  updateWorkType(id: string, workTypeData: UpdateWorkTypeData): void {
    this.store.dispatch(WorkTypesActions.updateWorkType({ id, workTypeData }));
  }

  deleteWorkType(id: string): void {
    this.store.dispatch(WorkTypesActions.deleteWorkType({ id }));
  }
}
